import React, { Component } from 'react'

class FormInput extends Component {
    render() {
        return (
            <div className={`form-group clearfix ${this.props.containerClass}`} style={this.props.containerStyle}>
                {this.props.label &&
                    <label className="control-label" htmlFor={this.props.labelFor}>{this.props.label}</label>
                }
                <div>
                    <input
                        id={this.props.labelFor}
                        type="text" {...this.props}
                        className="form-control"
                        onChange={(event) => this.props.onChange(event.target.value)} />
                </div>
            </div>
        )
    }
}

FormInput.defaultProps = {
    onChange(text) { }
}

export default FormInput;


// WEBPACK FOOTER //
// ./src/components/FormInput.js